 
export class ProdutoVM {
  constructor(
    public IdOperadora: string,

       public NomeOperadora: string,
      public Ans: string,
      public TipoProduto: string,
      public NomeProduto: string,
      public De: number,
      public Ate: number,
      public Valor: number,
      public Validade: string 
    ) {}
  }
  